import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import { User } from '../../user/User'

@InputType()
export class AddCollaboratorsArgs extends ActionArgs {
  @Field(() => [User])
  users: User[]

  @Field(() => String)
  extenalId: string
}
export interface IAddCollaborators extends IAction<void, AddCollaboratorsArgs> {}
